const fuseSettingsConfig = {
    layout          : {
        style : 'abaca',
        config: {
            scroll : 'content',
            navbar : {
                display : false,
                folded  : false,
                position: 'left'
            },
            toolbar: {
                display : true,
                style   : 'fixed',
                position: 'below'
            },
            footer : {
                display : false,
                style   : 'fixed',
                position: 'below'
            },
            leftSidePanel : {
                display : true,
            },
            rightSidePanel : {
                display : true,
            },
            mode   : 'fullwidth'
        }
    },
    customScrollbars: true,
    theme           : {
        main   : 'default',
        navbar : 'default',
        toolbar: 'default',
        footer : 'default'
    }
};

export default fuseSettingsConfig;